export default class Plugins
{
    constructor(plugins = [], source = undefined)
    {
        this.init()

        this.setSource(source)
        this.load(plugins)
    }

    init() {
        this._cache = {
            slots: {},
            pluginsPerSlot: {}
        }
        this.loadedPlugins = {}
        this.setSource(null)
    }

    setSource(source) {
        this.source = source
    }

    load(plugins = [])
    {
        let forUnload = []

        for( let plugin of plugins )
        {
            let pluginName, pluginObject

            if( typeOf(plugin) === 'object' ) {
                pluginName = plugin.name
                pluginObject = plugin
            } else {
                pluginName = plugin
            }

            if( pluginName === undefined || pluginName === '' ) {
                console.error('[Plugins]: Invalid plugin name: "'+ pluginName +'".')
                continue
            }

            // check for unload
            if( pluginName.charAt(0) === '-' ) {
                forUnload.push(pluginName.substr(1))
                continue
            }

            try {
                if (typeOf(plugin) === 'string') {
                    let requirePlugin = require.context("@/components/", true, /\.(vue|js)$/)
                    pluginObject = requirePlugin(`./${this.source}/plugins/${pluginName}/${pluginName}.plugin.js`).default
                }
            }
            catch( error ) {
                console.error('[Plugins]: Error in plugin: "'+ pluginName +'".', error)
                continue // skip on error
            }

            this.loadedPlugins[pluginName] = pluginObject
        }

        for( let pluginName in this.loadedPlugins ) {
            if( this.loadedPlugins[pluginName].afterLoad !== undefined ) {
                this.loadedPlugins[pluginName].afterLoad(this)
            }
        }

        for( let pluginName of forUnload ) {
            this.unload(pluginName)
        }
    }

    unload(plugin) {
        if( this.isLoaded(plugin) ) {
            delete this.loadedPlugins[plugin]
        }
    }

    isLoaded(plugin) {
        return inArray(plugin, this.getLoadedPluginNames())
    }

    getMixins() {
        let mixins = []
        for(let pluginName in this.loadedPlugins) {
            if( typeOf(this.loadedPlugins[pluginName].mixins) === 'function' ) {
                mixins.push(this.loadedPlugins[pluginName].mixins())
            }
        }
        return mixins
    }

    getSlot(plugin, slotName) {
        // try to extract from the cache
        if( typeof this._cache.slots[plugin] !== 'undefined' && typeof this._cache.slots[plugin][slotName] !== 'undefined' ) {
            return this._cache.slots[plugin][slotName]
        }
        //

        let pluginSlots = this.getSlots(plugin)
        let _parsed = false

        for(let slot of pluginSlots) {
            if(typeOf(slot) === 'string') {
                if (slot === slotName) {
                    _parsed = {slot: slotName, component: `dtable-plugin-${slotName}`}
                    break
                }
            }
            else if(typeOf(slot) === 'object') {
                if (slot.slot === slotName) {
                    _parsed = slot
                    break
                }
            }
            else {
                throw new Error('[Plugins] Invalid plugin slots() format.')
            }
        }

        if( false !== _parsed && typeOf(_parsed.condition) !== 'function' ) {
            _parsed.condition = () => true
        }

        // cahce parsed slot
        if(typeof this._cache.slots[plugin] === 'undefined') {
            this._cache.slots[plugin] = {}
        }
        this._cache.slots[plugin][slotName] = _parsed
        //

        return _parsed
    }

    getSlotPlugins(slot) {
        if( typeof this._cache.pluginsPerSlot[slot] !== 'undefined') {
            return this._cache.pluginsPerSlot[slot]
        }

        let _plugins = []
        let loaded = this.getLoadedPluginNames()
        for (let plugin of loaded) {
            if( false !== this.getSlot(plugin, slot) ) {
                _plugins.push(plugin)
            }
        }

        this._cache.pluginsPerSlot[slot] = _plugins

        return _plugins
    }

    getSlots(plugin) {
        if( typeOf(this.loadedPlugins[plugin].slots) !== 'function' ) {
            return []
        }
        return this.loadedPlugins[plugin].slots()
    }

    getLoadedPlugins() {
        return this.loadedPlugins
    }

    hasLoadedPlugins() {
        return this.getLoadedPlugins().length > 0
    }

    getLoadedPluginNames() {
        return Object.keys(this.loadedPlugins)
    }
}
